
















































import mixins from 'vue-typed-mixins';
import E2EMixin from '@/components/mixins/E2EMixin';
import S3Mixin from '@/components/mixins/s3';
import { CvExample } from '@/../gen';
import { makeExampleUrl, makeInputValue } from './utils';

export default mixins(E2EMixin, S3Mixin).extend({
  props: {
    cvExamples: {
      type: Array as () => CvExample[],
      required: true,
    },
    // v-model
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        innerCvSampleSelected: this.value,
      },
    };
  },
  watch: {
    'formData.innerCvSampleSelected'(val: number) {
      this.$emit('input', val);
    },
  },
  methods: {
    makeInputValue,
    makeExampleUrl,
  },
});
